import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconSocialMedia = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 37 39'>
    <title>{t('Social media')}</title>
    <path d='M29.88785 25.14953c-2.255074 0-4.252093 1.08253-5.516495 2.75114l-10.895944-6.16674c.239103-.70163.375056-1.45138.375056-2.23393 0-.73626-.117-1.44482-.330224-2.11037l10.929112-6.1857c1.268047 1.60957 3.230439 2.64654 5.438495 2.64654 3.824552 0 6.925234-3.10068 6.925234-6.92524C36.813084 3.10068 33.712402 0 29.88785 0c-3.824551 0-6.925233 3.10068-6.925233 6.92523 0 .80698.145065 1.57859.399112 2.29882l-10.878813 6.15689c-1.261851-1.69996-3.278187-2.80617-5.557682-2.80617C3.100682 12.57477 0 15.67545 0 19.5s3.100682 6.92523 6.925234 6.92523c2.232841 0 4.213093-1.06102 5.479682-2.70157l10.911617 6.17549c-.226711.68487-.353916 1.41493-.353916 2.17562 0 3.82455 3.100682 6.92523 6.925233 6.92523 3.824552 0 6.925234-3.10068 6.925234-6.92523 0-3.82456-3.100682-6.92524-6.925234-6.92524'
      fill={fill} fillRule='evenodd' />
  </svg>
)

export default Icon(IconSocialMedia)
